// @flow

import { connect } from 'react-redux';
import './memberworks.scss';
import { titleCase, formatArtistName } from '../../utilities/text';
import { SearchResults } from '../../components/works';
import { searchByCae, consumeSearchHistoryItem } from '../../services/search';

const mapState = ({ search }) => {
  const prevHistory = search.searchParamsHistory.length && search.searchParamsHistory[0];
  return {
    className: 'member-works',
    title: titleCase(formatArtistName(search.searchMeta.artistName)),
    membershipNo: search.searchParams.caeNumber || '----',
    backLinkText: (prevHistory && titleCase(prevHistory.title)) || 'Home',
    backLinkTo: (prevHistory && prevHistory.page) || '/',
    linkTo: '/memberwork',
  };
};

const mapDispatch = {
  getWorks: searchByCae,
  backLinkOnClick: consumeSearchHistoryItem,
};

export default connect(
  mapState,
  mapDispatch,
)(SearchResults);
